import { FC, useState } from 'react';
import { UseFormRegister } from 'react-hook-form';

export interface Input {
  name: string;
  required?: boolean;
  id?: string;
  label?: string;
  placeholder?: string;
  type?: 'text' | 'password' | 'email';
  pattern?: RegExp;
  prefixIcon?: string;
  isError?: boolean;
  register: UseFormRegister<any>;
}

export const Input: FC<Input> = ({
  name,
  label,
  id,
  type,
  required,
  placeholder,
  pattern,
  prefixIcon,
  register,
  isError,
}) => {
  const [buttonType, setButtonType] = useState(type);

  return (
    <div>
      {label && id && (
        <label className="mb-1 block text-sm font-medium" htmlFor={id}>
          {label}
        </label>
      )}

      <div className="relative">
        {prefixIcon && (
          <div
            className="absolute flex h-full items-center px-2
          "
          >
            <img src={prefixIcon} alt="Input icon" />
          </div>
        )}
        <input
          type={buttonType}
          id={id}
          placeholder={placeholder}
          className={`h-full w-full rounded-md border border-grayish p-2 
          ${prefixIcon ? 'pl-8' : ''}
          ${isError ? 'border-error outline outline-2 outline-error' : ''}
          `}
          {...register(name, {
            required,
            pattern,
          })}
        />

        {type === 'password' && (
          <div
            className="absolute right-0 top-0 flex h-full items-center px-2
          "
          >
            {buttonType === 'password' && (
              <button
                type="button"
                onClick={() => {
                  setButtonType('text');
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="#666"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </button>
            )}

            {buttonType === 'text' && (
              <button type="button" onClick={() => setButtonType('password')}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="#666"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                  />
                </svg>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
